module.exports = __webpack_public_path__ + "static/media/bg_tariffs.3e3d0d6f.svg";